import { Injectable } from '@angular/core';
import { Observable, forkJoin } from 'rxjs';
import { map } from 'rxjs/operators';
import { Api } from 'app/core/api.service';
import { ServiceType } from 'app/core/service-type.model';
import { camelCaseObject } from 'app/core/case-transform';
import { getFromToQuarter } from 'app/core/date/functions';
import { ISOStringForCurrentTime } from 'app/core/date/functions';

export interface Consumption {
  application: string;
  day: number;
  taskCount: number;
  documentCount: number;
  pageCount: number;
  pageLimit: number;
}

export interface Bill {
  application: string;
  pages: number;
  documents: number;
}
export interface BillResponseToCamelCaseObj {
  demo: {
    documentCount: number,
    pageCount: number
  },
  paid: {
    documentCount: number,
    pageCount: number
  }
}

export interface BillResponse {
  demo: {
    document_count: number,
    page_count: number
  },
  paid: {
    document_count: number,
    page_count: number
  }
}

@Injectable()
export class ConsumptionService {

  constructor(private api: Api) {}

  getBillOverview(owner: string, from: Date, to: Date): Observable<Bill[]> {
    const params = {
      from: ISOStringForCurrentTime(from),
      to: ISOStringForCurrentTime(to)
    };
    return this.api
      .get(`/v2/system/task/${owner.toLocaleLowerCase()}/bills`, { params })
      .pipe(map(response => camelCaseObject(response) || []));
  }

  getConsumption(serviceType: ServiceType, from: Date = null, to: Date = null): Observable<BillResponseToCamelCaseObj> {
    const fromToQuater = getFromToQuarter();

    const params = {
      from: from ? ISOStringForCurrentTime(from) : ISOStringForCurrentTime(fromToQuater.from),
      to: to ? ISOStringForCurrentTime(to) : ISOStringForCurrentTime(fromToQuater.to)
    };

    const demoParams = {
        from: from ? ISOStringForCurrentTime(from) : new Date(0).toISOString(),
        to: to ? ISOStringForCurrentTime(to) : ISOStringForCurrentTime(fromToQuater.to)
    };

    return forkJoin([
      this.api.get(`/v2/task/${serviceType}/bill`, { params: demoParams }),
      this.api.get(`/v2/task/${serviceType}/bill`, { params })
    ]).pipe(map((responses: BillResponse[]) => {
      const [demoResponse, customResponse] = camelCaseObject(responses);
      return {
        demo: {
          documentCount: demoResponse.demo.documentCount || 0,
          pageCount: demoResponse.demo.pageCount || 0,
        },
        paid: {
          documentCount: customResponse.paid.documentCount || 0,
          pageCount: customResponse.paid.pageCount || 0,
        },
      };
    }));


  }
}
